var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Stack, lighten, alpha } from "@mui/material";
import CircularProgress from "../Progress/CircularProgress";
import { COLORS } from "../../../constants/colors";
var Loader = function (_a) {
    var full = _a.full, translucent = _a.translucent;
    if (full) {
        return (_jsx(Stack, __assign({ height: "100vh", width: "100%", alignItems: "center", justifyContent: "center", position: "fixed", top: "0", left: "0", zIndex: "10", bgcolor: translucent
                ? alpha(COLORS.LIGHT_GREY, 0.5)
                : lighten(COLORS.LIGHT_GREY, 0.5) }, { children: _jsx(CircularProgress, {}) })));
    }
    return (_jsx(Stack, __assign({ mt: 4, alignItems: "center", justifyContent: "center" }, { children: _jsx(CircularProgress, {}) })));
};
export default Loader;
